import consolv from "lib/consolv";
import MasterControlProgram from "./MCP";

const defaultConfig = {
  pubId: "partner-pub-7080596664555345",
  afs: {
    enabled: false,
    styleId: 7597944076,
    adsafe: "high",
    divSelector: "[data-slot-type=ad_adsense_search]",
    divId: "ad_adsense_search",
    linkTarget: "_blank",
  },
  cdm: {
    enabled: false,
    divSelector: "[data-slot-type=ad_adsense_cdm]",
    divId: "ad_adsense_cdm",
    resultsPageBaseUrl: "{origin}/search/",
    resultsPageQueryParam: "searchTerm",
    adtest: "off",
  },
};

function setupGoogCsa() {
  window._googCsa =
    window._googCsa ||
    function () {
      window._googCsa!.q = window._googCsa!.q || [];
      window._googCsa!.q.push(arguments);
    };
  window._googCsa!.t = Date.now();
}

const setupAdSenseForSearch = (
  MCP: MasterControlProgram,
  config: typeof defaultConfig,
) => {
  setupGoogCsa();

  const pageOptions = {
    pubId: config.pubId,
    query: MCP.Configurator!.meta.page.keyterm,
    styleId: config.afs.styleId,
    adsafe: config.afs.adsafe,
    linkTarget: config.afs.linkTarget,
  };

  const container = document.querySelector(config.afs.divSelector);
  if (!container) return;

  container.id = config.afs.divId;
  const boundingRect = container.getBoundingClientRect();

  const block1 = {
    container: config.afs.divId,
    width: boundingRect.width,
  };

  window._googCsa!("ads", pageOptions, block1);
};

const setupContentDiscovery = (
  MCP: MasterControlProgram,
  config: typeof defaultConfig,
) => {
  setupGoogCsa();

  const container = document.querySelector(config.cdm.divSelector);
  if (!container) return;

  container.id = config.cdm.divId;

  const pageOptions = {
    pubId: config.pubId,
    pageType: "article",
    resultsPageBaseUrl: config.cdm.resultsPageBaseUrl.replace(
      /{origin}/,
      window.location.origin,
    ),
    resultsPageQueryParam: config.cdm.resultsPageQueryParam,
    adtest: config.cdm.adtest,
  };

  const block1 = { container: config.cdm.divId };

  window._googCsa!("cdm", pageOptions, block1);
};

/**
 * Generates the configuration and sets up event listeners for slot loads
 * @param {MCPInstance} MCP
 */
export default function AdSenseAdapter(MCP: MasterControlProgram) {
  MCP.loaded.then(() => {
    const { adSense } = MCP.Configurator!.getConfiguration({
      defaults: { adSense: defaultConfig },
    }) as { adSense: typeof defaultConfig };

    if (
      adSense.afs.enabled &&
      document.querySelector(adSense.afs.divSelector)
    ) {
      consolv.log("MCP: Enabling AdSense for Search");

      setupAdSenseForSearch(MCP, adSense);
    }

    if (
      adSense?.cdm?.enabled &&
      document.querySelector(adSense.cdm.divSelector)
    ) {
      consolv.log("MCP: Enabling AdSense Content Discovery & Monetization");
      setupContentDiscovery(MCP, adSense);
    }
  });
}
